import React from "react";
import { Link } from "react-router-dom";
import singleClick from "../../images/hireDeveloper/singleClick.jpg";
import Contactform from "../home/contactform";

const SingleClick = ({ reference }) => {
  return (
    <>
      <section
        className="hireSingleClickSection"
        style={{ backgroundImage: `url(${singleClick})` }}
        ref={reference}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-5 col-lg-5 col-md-6 mb-5 mb-md-0">
              <div className="details" data-aos="zoom-in">
                <h3>
                  Get Highly Skilled <span>Resources Remotely</span>
                </h3>
                <p className="mb-5">
                  Just brief us on your requirements, You will be immediately
                  responded with a resource on board.
                </p>
                <Link to="/HireDeveloper" className="btn">
                  <span>Hire Top Developer</span>
                </Link>
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 col-md-6 ml-auto"
              data-aos="zoom-in"
            >
              <Contactform />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SingleClick;
